<template>
    <form
        :class="[
            'formbox-signin',
            { 'is-name-required': isNameRequired },
            { 'is-busy': isBusy }
        ]"
        @submit.prevent="onSubmit"
    >
        <Validatable ref="validatable">
            <div class="formbox-signin-item overflow-visible">
                <InputNumberMultiple
                    v-model="cardNumber"
                    :items-lengths="[3, 6, 3]"
                    :is-required="true"
                    label="Login - numer karty MAKRO"
                />
                <Tooltip>
                    <p v-bastards>
                        W trzech kolejnych polach przepisz cyfry z trzech kolejnych członów numeru swojej karty. Numer twojej karty może mieć 9,10 lub 12 cyfr.
                    </p>
                </Tooltip>
            </div>
            <div :class="[
                'formbox-signin-item',
                'is-paddingless',
                { 'is-hidden': !isNameRequired }
            ]">
                <InputTextMultiple
                    v-model="name"
                    :items="['Imię', 'Nazwisko']"
                    :is-required="isNameRequired"
                />
            </div>
            <div class="formbox-signin-item">
                <InputNumber
                    v-model="nip"
                    :maxlength="10"
                    :is-required="true"
                    label="NIP"
                />
            </div>
            <div class="formbox-signin-item">
                <button class="btn btn--upper btn-c--primary btn-s--large">
                    Zaloguj
                </button>
            </div>
        </Validatable>
        <div :class="[
            'formbox-signin-plug',
            'flex',
            'flex-content-center',
            'flex-column',
            { 'is-active': isNameRequired && fullName === null }
        ]">
            <span class="text-bold text-paragraph text-center fs-15">
                Uwaga:
            </span>
            <span
                v-bastards
                class="text-paragraph text-center fs-15"
            >
                Dla tej karty należy podać dodatkowo imię i nazwisko posiadacza karty
            </span>
        </div>
        <LoaderOverlay :is-active="isBusy" />

        <Modal
            :is-closeable="true"
            ref="modal"
        />
    </form>
</template>

<script>
import LoaderOverlay from '@/components/loader/LoaderOverlay'
import Modal from '@/components/modal/Modal'

export default {
    components: {
        LoaderOverlay,
        Modal
    },

    data() {
        return {
            cardNumber: [],
            name: [],
            nip: '',
            isNameRequired: false,
            isBusy: false
        }
    },

    computed: {
        fullName () {
            if (this.name.length !== 2 || this.name[0].length === 0 || this.name[1].length === 0) {
                return null
            }

            return `${this.name.firstName} ${this.name.lastName}`
        }
    },

    watch: {
        cardNumber(value) {
            this.isNameRequired = this.isOldCardNumber(value)
        },

        name(value) {
            console.log(value)
        }
    },

    mounted() {
        // this.cardNumber.push('???')
    },

    methods: {
        isOldCardNumber (numbersArray) {
            if (numbersArray.length !== 3) {
                return false
            }

            return numbersArray[0].length === 2
                && (numbersArray[1].length === 5 || numbersArray[1].length === 6)
                && numbersArray[2].length === 2
        },

        onSubmit() {
            const isValid = this.$refs.validatable.validate()

            if (!isValid) {
                // scroll?
                return
            }

            this.handleFormSubmit()
        },

        handleFormSubmit() {
            console.log('[FormboxSignin] fire handleFormSubmit')

            this.isBusy = true

            this.$store.dispatch('apiAuth/login', {
                partCard1: this.cardNumber[0] || '',
                partCard2: this.cardNumber[1] || '',
                partCard3: this.cardNumber[2] || '',
                firstName: this.name[0] || '',
                lastName: this.name[1] || '',
                customerNip: this.nip
            })
                .then(() => {
                    this.$router.push({
                        name: 'zgody'
                    })
                })
                .catch(e => {
                    this.isBusy = false

                    this.$refs.modal
                        .open(`<header class="fs-32">Błąd logowania.</header><p class="fs-22">${e.response.data.message || ''}</p>`, 'center-small', function() {
                            console.log('closed')
                        })
                })

            // this.isBusy = true

            // setTimeout(() => {
            //     this.$router.push({ name: 'zgody' })
            // }, 2000)
        }
    }
}
</script>

<style lang="scss">
.formbox-signin {
    @include transition(max-height .2s ease-in-out 0s);
    position: relative;
    max-height: 273px;

    &.is-name-required {
        max-height: 336px;
    }

    &-item {
        @include transition(opacity .2s ease-in-out 0s, height 0s linear 0s, max-height .2s ease-in-out 0s);
        position: relative;
        overflow:  hidden;
        max-height: 113px;
        opacity: 1;

        &.is-paddingless {
            max-height: 63px;
        }

        & + & {
            &:not(.is-paddingless) {
                padding-top: 30px;
            }
        }

        &.is-hidden {
            max-height: 0;
        }
    }

    &-plug {
        @include position-cover(-1px);
        @include hide();
        @include transition(.1s);
        background-color: $color-secondary;
        pointer-events: none;
        top: 159px;
        padding: 0 15%;
        z-index: 1;

        &.is-active {
            @include show();
            pointer-events: auto;
        }
    }
}
</style>
